import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { PageHeader } from 'antd'
import * as React from 'react'
import { ai } from '../../TelemetryService';

import { IAppContext, withAppContext } from '../AppContext';
import { Dashboard } from './Dashboard';

export class PageDashboardCmp extends React.Component<IAppContext, any> {

    constructor(props) {
        super(props)
    }

    render() {
        return (
                <Dashboard anno={this.props.appContext.Anno} />
        )
    }
}

export const PageDashboard = withAppContext(withAITracking(ai.reactPlugin, PageDashboardCmp,"PageDashboard"))